import StatsLineGraph from "./stats_line_graph";
import React, { PureComponent } from "react";
import { classNames } from "react-extras";
import StatsPageTable from "./stats_page_table";
import { DropdownButton, MenuItem } from "react-bootstrap";
import { getData, getDateFormatted } from "../../lib/format_stats";

export default class StatsTotalDownloads extends PureComponent {
  state = {
    display: "chart",
  };

  getColumnInfo = () => [
    {
      accessor: "date",
      Header: "Date",
      Cell: this.getDateFormatted,
    },
    {
      accessor: "count",
      Header: "Downloads",
      Cell: ({ row }) => (row.count || 0).toLocaleString(),
    },
  ];

  selectDisplay = key => {
    this.setState({ display: key });
  };

  renderData() {
    if (this.props.isLoading) {
      return null;
    }
    switch (this.state.display) {
      case "chart":
        return <StatsLineGraph data={this.props.data} statsForm={this.props.statsForm} />;
      case "table":
        return <StatsPageTable data={this.getData()} columns={this.getColumnInfo()} />;
      default:
        return null;
    }
  }
  render() {
    return (
      <div
        className={classNames(
          "stats-total-downloads",
          "stats-table",
          this.props.wideMode && "stats-total-downloads--wide-mode"
        )}>
        <DropdownButton
          id={"total-downloads-dropdown"}
          title={`Show ${this.state.display}`}
          bsSize={"small"}>
          <MenuItem eventKey={"chart"} onSelect={this.selectDisplay}>
            Show chart
          </MenuItem>
          <MenuItem eventKey={"table"} onSelect={this.selectDisplay}>
            Show table
          </MenuItem>
        </DropdownButton>
        {this.renderData()}
      </div>
    );
  }

  getDateFormatted = rowProps => getDateFormatted(rowProps, this.props.statsForm);

  getData = () => {
    if (!this.props.data || !this.props.data.length) return [];
    return getData(this.props.data);
  };
}
